var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.477,
    height: 19.892,
    viewBox: "0 0 24.477 19.892",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-twitter",
    d: "M24.419,7.971a10.046,10.046,0,0,1-2.886.792,5.034,5.034,0,0,0,2.209-2.778A10.084,10.084,0,0,1,20.552,7.2,5.024,5.024,0,0,0,12,11.783,14.259,14.259,0,0,1,1.645,6.535,5.033,5.033,0,0,0,3.2,13.242a5.018,5.018,0,0,1-2.276-.63v.063A5.029,5.029,0,0,0,4.951,17.6a5.026,5.026,0,0,1-1.322.175,4.837,4.837,0,0,1-.946-.092,5.033,5.033,0,0,0,4.691,3.489,10.067,10.067,0,0,1-6.236,2.148,9.88,9.88,0,0,1-1.2-.071,14.189,14.189,0,0,0,7.7,2.257A14.19,14.19,0,0,0,21.927,11.222c0-.218-.006-.437-.013-.651A10.209,10.209,0,0,0,24.419,7.971Z",
    transform: "translate(0.059 -5.617)",
    fill: "#191919"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7a5418d792b9e036414c921633742e55.svg";
export { ForwardRef as ReactComponent };